/** Remark / proof policy values exactly as the AbsenceReasons API sends and accepts them. */
export enum AbsenceReasonPolicy {
  REQUIRED = 'Required',
  OPTIONAL = 'Optional',
}
